import cx from "classnames";
import { node, string } from "prop-types";
import React from "react";
import { Container } from "@chaser/components";
import style from "./PageContainer.module.scss";
import { useBottomNotificationContext } from "../BottomNotification/bottomNotificationContext";
import PlanUpgradeBanner from "../PlanUpgradeBanner";
import useShortCode from "../../hooks/useShortCode";

const PageContainer = ({ children, className, ...rest }) => {
  const shortCode = useShortCode();
  const notificationShowing = useBottomNotificationContext();

  return (
    <Container
      className={cx(
        style.content,
        notificationShowing && style.additionalMargin,
        className,
      )}
      display="flex"
      flexDirection="column"
      maxWidth="1250px"
      py="large"
      {...rest}
    >
      {shortCode && <PlanUpgradeBanner />}
      {children}
    </Container>
  );
};

PageContainer.propTypes = {
  children: node,
  className: string,
};

export default PageContainer;
